var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressLogsGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46193 4.62864C8.50437 4.71503 8.53241 4.80754 8.54496 4.90265L8.77699 8.35258L8.89216 10.0866C8.89335 10.2649 8.92133 10.4421 8.97519 10.6124C9.1143 10.9428 9.44894 11.1528 9.81301 11.1382L15.3607 10.7753C15.601 10.7714 15.833 10.8612 16.0057 11.0251C16.1496 11.1617 16.2425 11.3403 16.2718 11.5325L16.2816 11.6492C16.052 14.8281 13.7173 17.4796 10.5449 18.164C7.3726 18.8485 4.11952 17.4026 2.55189 14.6114C2.09996 13.8005 1.81768 12.9092 1.72162 11.9898C1.68149 11.7177 1.66382 11.4428 1.66878 11.1678C1.66383 7.75964 4.09086 4.81316 7.48825 4.10284C7.89714 4.03917 8.29799 4.25563 8.46193 4.62864Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.7271 1.6667C14.527 1.76337 17.7207 4.49584 18.3354 8.17626L18.3296 8.20341L18.3128 8.24291L18.3151 8.35132C18.3064 8.49494 18.251 8.63313 18.1554 8.74475C18.0558 8.86103 17.9198 8.94021 17.7701 8.97094L17.6787 8.98347L11.2781 9.39819C11.0652 9.41919 10.8532 9.35053 10.6949 9.20931C10.5629 9.09163 10.4786 8.93276 10.4548 8.76158L10.0251 2.37023C10.0177 2.34862 10.0177 2.3252 10.0251 2.30358C10.031 2.12741 10.1086 1.96088 10.2405 1.84121C10.3724 1.72153 10.5476 1.65868 10.7271 1.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressLogsGraphIcon);
export default __webpack_public_path__ + "static/media/progress_logs_graph_icon.00c022024338916fdd7ac6eb99e72264.svg";
export { ForwardRef as ReactComponent };